export { default as FavoriteHeader } from './FavoriteHeader';
